import { RootState } from 'redux/store';

export const getNotificationList = (state: RootState) =>
  state.notifications.notificationList;

export const getNewNotificationCounts = (state: RootState) =>
  state.notifications.newNotificationCounts;

export const getUnreadNotificationCounts = (state: RootState) =>
  state.notifications.unreadNotificationCounts;
